import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { useAuth, useAuthActions } from 'hooks';
import { LogoutIcon, AccountPersonIcon } from 'components/elements/Icons';
import { SettingsButtonTabs } from 'components/elements/navigation';
import { routes } from 'const';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function SettingsMenu({ onSelectTab }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const history = useHistory();
  const userActions = useAuthActions();

  const {
    user: { firstName, lastName },
  } = useAuth((state) => state.account);

  const logout = () => userActions.logout().then(() => history.push(routes.login));

  return (
    <div className={classes.settingsMenu} data-testid="settings-menu">
      <div className={classes.settingsMenuWrapper}>
        <div>
          <div className={classes.userWrapper}>
            <AccountPersonIcon classes={classes.personIcon} />
            <div className={classes.userNameWrapper}>
              <Typography className={classes.userName} variant="body1" component="h6">
                {firstName}
              </Typography>
              <Typography className={classes.userLastName} variant="body1" component="h6">
                {lastName}
              </Typography>
            </div>
          </div>
          <SettingsButtonTabs onSelectTab={onSelectTab} />
        </div>
        <Button className={classes.logoutButton} onClick={logout} color="primary">
          <LogoutIcon classes={classes.logoutIcon} />
          <Typography className={classes.logoutButtonText} variant="body1" component="span" color="error">
            {t('logout')}
          </Typography>
        </Button>
      </div>
    </div>
  );
}

SettingsMenu.propTypes = {
  onSelectTab: PropTypes.func.isRequired,
};

export default SettingsMenu;
